import { sha256 } from 'js-sha256';

import { MeQuery } from '@/modules/profile/gql/__generated/meQuery.generated';

// SHA256 encrypted email address
export function encryptEmail(email: string): string {
  const normalizeEmail = email.toLowerCase().trim();

  return sha256(normalizeEmail);
}

// Generate a random id for anonymous users
export function generateRandomId(): string {
  if (typeof window === 'undefined') {
    return '';
  }

  return Math.random().toString(36).substring(2);
}

export type UserProps = MeQuery['me']['customer'] & {
  authenticated?: boolean | null;
};

// Parse user data to data layer
export function parseUserToDataLayer(user?: UserProps | null) {
  const userType = user?.custom?.customFieldsRaw?.find(
    (field) => field.name === 'customer-type'
  )?.value;
  const ajsAnonymousId = localStorage.getItem('ajs_anonymous_id')?.replaceAll('"', '');
  const lastLoggedUserId = localStorage.getItem('user_id');
  const user_id = user?.id ?? lastLoggedUserId;

  const userEvent = {
    status: user_id ? 'Authenticated' : 'Unauthenticated',
  } as {
    user_id?: string;
    ajs_anonymous_id?: string;
    type?: string;
    group?: string;
    email?: string;
    email_hash?: string;
    status: string;
  };

  if (user_id) {
    // set user_id to the local storage id if it exists
    window.localStorage.setItem('user_id', user_id);
    userEvent.user_id = user_id;
  }

  if (ajsAnonymousId) {
    userEvent.ajs_anonymous_id = ajsAnonymousId;
  }

  if (userType) {
    userEvent.type = userType;
  }

  if (user?.customerGroup?.key) {
    userEvent.group = user.customerGroup.key;
  }
  if (user?.email) {
    userEvent.email = user.email;
    userEvent.email_hash = encryptEmail(user.email);
  }

  return userEvent;
}
